<template>
  <loader
    v-show="commonStore.loader"
    name="dots"
    object="#d2b88f"
    size="5"
    speed="2"
    bg="#343a40"
    objectbg="#999793"
    opacity="20"
    :disableScrolling="false"
  ></loader>
  <header-box-3></header-box-3>
  <main :class="pageClass">
    <router-view @updatePageClass="handlePageClass"></router-view>
  </main>
  <footer-box-6></footer-box-6>
  <modal-access
    v-if="isPortalTypeBooks"
    title="Join now to get more"
    text="Sign up for MoreHighlighter and get access to all our content."
  ></modal-access>
  <modal-access
    v-else
    title="Enjoy all our<br />beauty content"
    text="Membership to MoreHighlighter and unlock access to all our content."
  ></modal-access>
</template>

<script>
import { useAuthStore, useCommonStore, useEnabledStore } from "@/stores";
import { RouterView } from "vue-router";
import HeaderBox3 from "./components/layouts/header/HeaderBox3.vue";
import FooterBox6 from "./components/layouts/footer/FooterBox6.vue";
import ModalAccess from "@/components/modals/ModalAccess.vue";

export default {
  components: {
    RouterView,
    HeaderBox3,
    FooterBox6,
    ModalAccess,
  },
  data() {
    return {
      pageClass: "",
      commonStore: useCommonStore(),
      authStore: useAuthStore(),
      enabledStore: useEnabledStore(),
    };
  },
  watch: {
    $route(to, from) {
      this.pageClass = "";
    },
  },
  methods: {
    handlePageClass(newClass) {
      this.pageClass = newClass;
    },
  },
  computed: {
    isAuth() {
      return this.authStore.isAuth;
    },
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    },
  },
};
</script>
